import { makeUniqueId } from 'utilities/data';
import { BaseDistinctIdProvider } from './base_distinct_id_provider';

export class NonPersistentDistinctIdProvider extends BaseDistinctIdProvider {
    getIdInfo() {
        return new Promise(resolve => {
            this.userInfo.uid = makeUniqueId();
            requestAnimationFrame(() => resolve(this.userInfo));
        });
    }
}